import About from 'features/about/About'
import Layout from 'components/layout/Layout'
import { useTranslation } from 'next-i18next/pages'
import type { SeoProps } from 'components/seo/types'
import { serverSideTranslations } from 'next-i18next/pages/serverSideTranslations'
import i18nConfig from 'utils/i18nConfig'
import { DEFAULT_NAMESPACES } from 'constants/i18n'

const AboutPage = () => {
  // i18n
  const { t } = useTranslation('about')

  // Constants
  const seo: SeoProps = {
    description: t('seo.description'),
    title: t('seo.title')
  }

  return (
    <Layout {...{ seo }}>
      <About />
    </Layout>
  )
}

export const getStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, [...DEFAULT_NAMESPACES, 'about'], i18nConfig))
    }
  }
}

export default AboutPage
